import PropTypes from "prop-types"


const properties = {
  familyName: PropTypes.string.isRequired,
  givenName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
}

const PublicBrokerShape = PropTypes.exact(properties)

export default PublicBrokerShape
export { properties }
